<template>
    <!-- <div class="max-h-[285px] overflow-auto flex flex-col rounded-md shadow-md p-4 mt-2 bg-white w-[282px] mx-auto "> -->
   <div 
    v-on-clickaway="closeDropdown"
    :class="dropdownPanelClasses"
    >
     <div class="modal-content-board">
       <!-- Close Button -->
       <woot-button
         icon="dismiss"
         class="button modal--close clear button--only-icon secondary"
         @click="$emit('close')"
       />
       <h3 class="text-[15px] mt-[8px] font-semibold text-slate-800 dark:text-slate-100">{{ heading }}</h3>
 
       <!-- Search Bar -->
       <div class="mt-4">
      <input
        type="text"
        v-model="search"
        :placeholder="searchPlaceholder"
        class="search-input w-full border border-gray-300 rounded-md px-1.5 py-0.5 text-sm mb-2"
      />
       </div>
 
       <!-- Board List -->
       <div class="mt-2 min-h-[120px] max-h-32 overflow-y-auto">
         <LabelDropdownItem
           v-for="state in filteredStates"
           :key="state.id"
           :title="state.name"
           :color="state.color"
           :selected="state.id === selectedState?.id"
           :class="{ 'disabled-item': state.id === selectedState?.id }"
           :disabled="state.id === selectedState?.id"
           @click="state.id !== selectedState?.id && selectState(state)" 
         />
         <div
     v-if="noResult"
     class="text-sm text-gray-600 dark:text-white px-2 py-4 text-center"
   >
   No results found
   </div>
       </div>
     </div>
   </div>
   <!-- </div> -->
 </template>
   
 <script>
 import LabelDropdownItem from 'shared/components/ui/label/LabelDropdownItem.vue';
 import { picoSearch } from '@scmmishra/pico-search';
 import { mixin as clickaway } from 'vue-clickaway';
 
 export default {
   components: { LabelDropdownItem },
   mixins: [clickaway],
   props: {
     states: {
       type: Array,
       required: true,
     },
     selectedState: {
       type: Object,
       default: null,
     },
    heading: {
      type: String,
      default: 'Select',
    },
    searchPlaceholder: {
      type: String,
      default: 'Search...',
    },
    /** Anchor panel to the triggering cell’s right edge (avoids clipping near the viewport). */
    alignMenuRight: {
      type: Boolean,
      default: false,
    },
    /**
     * When true, the panel anchors to its offset parent immediately below it (popover style).
     * Use with a positioned wrapper (zero-size point under the trigger). Omit legacy bottom/right offsets.
     */
    attachBelow: {
      type: Boolean,
      default: false,
    },
  },
   data() {
     return {
       search: '',
     };
   },
   computed: {
   dropdownPanelClasses() {
     /* Match kivo/crm-main-v2: fixed 250px panel, same list min/max height as legacy */
     const width = 'w-[250px]';
     const base =
       'bg-white dark:bg-slate-800 rounded-lg shadow-lg border border-slate-100 dark:border-slate-700';

      if (this.attachBelow) {
        const horiz = this.alignMenuRight ? 'left-auto right-0' : 'left-0 right-auto';
        return [
          `${base}`,
          width,
          /* Stay below primary sidebar (z-33) so nav/backdrop behavior is unchanged */
          'absolute top-0 z-[20]',
          horiz,
        ];
      }

      const alignLegacy = this.alignMenuRight ? 'right-0 left-auto' : 'left-0';
      return [
        `absolute bottom-[75px] translate-y-full ${base} z-10`,
        width,
        alignLegacy,
      ];
    },
    filteredStates() {
  if (!Array.isArray(this.states)) return [];

  return !this.search
    ? this.states
    : picoSearch(this.states, this.search, ['name'], { threshold: 0.9 });
},
 noResult() {
  return Array.isArray(this.filteredStates) && this.filteredStates.length === 0;
}
   },
   methods: {
     closeDropdown() {
       this.$emit('close'); // Emit the close event to the parent
     },
     selectState(state) {
       this.$emit('select', state); // Emit the selected board to the parent
       this.$emit('close'); // Close the modal after selection
     },
   },
 };
 </script>
 
 <style scoped>
 /* .modal {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background-color: rgba(0, 0, 0, 0.5);
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 1000;
 } */
 
 
 
.modal-content-board {
  @apply bg-white dark:bg-slate-800;
  padding: 10px;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
}

 .search-bar {
   width: 100%;
   padding: 8px;
   margin-bottom: 10px;
   border: 1px solid #ccc;
   border-radius: 4px;
 }
 
 .board-list {
   max-height: 300px;
   overflow-y: auto;
   background-color: #f9f9f9; /* Change background color */
   border: 1px solid #ddd; /* Add border */
   border-radius: 4px; /* Add rounded corners */
 
 }
 label-dropdown-item {
   border: 2px solid red; /* Temporary for debugging */
 }
 
 /* label-dropdown-item {
   color: #000; 
   padding: 8px;
   color: #333; 
   background-color: #fff; 
   border-bottom: 1px solid #eee; 
 }
 
 label-dropdown-item:hover {
   background-color: #f0f0f0; 
   color: #000;
 } */
 .disabled-item {
   pointer-events: none; /* Disable interactions */
   /* opacity: 0.5;  */
 }
 </style>